import React from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import { API, getAuthToken, setAuthToken } from "@/lib/api";
import { Loader2 } from "lucide-react";

const AuthContext = React.createContext(null);

export function AuthProvider({ children }) {
  // undefined = checking, null = not authenticated, object = authenticated
  const [user, setUser] = React.useState(undefined);

  React.useEffect(() => {
    const token = getAuthToken();
    if (!token) {
      setUser(null);
      return;
    }
    axios
      .get(`${API}/auth/me`)
      .then((r) => setUser(r.data))
      .catch(() => {
        setAuthToken(null);
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    setAuthToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    setAuthToken(null);
    setUser(null);
    window.location.assign("/login");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>
  );
}

export function useAuth() {
  return React.useContext(AuthContext);
}

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f4f5f7]">
        <Loader2 className="w-8 h-8 text-[#E2333F] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
